export default function StructuredData({ data }) {
    const payload = (Array.isArray(data) ? data : [data]).filter(Boolean);

    if (!payload.length) {
        return null;
    }

    const json = JSON.stringify(payload.length === 1 ? payload[0] : payload).replace(/</g, "\\u003c");

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: json }}
        />
    );
}
